import { gql } from '@apollo/client';

export const FETCH_REBALANCE_TIMESTAMP = gql`
  query fetchBulkTraderTimestamp($bulkTraderId: ObjectID!) {
    fetchBulkTradeRun(bulkTradeRunId: $bulkTraderId) {
      bulkTradeRun {
        createdAt
      }
    }
  }
`;
